(function () {
  'use strict';

  var STORAGE_KEY = 'llc_splash_seen';
  var HOME_SMOKE_KEY = 'llc_home_smoke_seen';

  var splash = document.getElementById('llc-splash');
  var splashCanvas = document.getElementById('llc-splash-canvas');
  var logoWrap = document.getElementById('llc-logo-wrap');
  var logoImg = document.getElementById('llc-logo-img');
  var siteCanvas = document.getElementById('llc-site-smoke-canvas');

  if (!splash || !splashCanvas || !logoWrap || !logoImg) return;

  if (sessionStorage.getItem(STORAGE_KEY)) {
    splash.style.display = 'none';
    if (siteCanvas) siteCanvas.style.display = 'none';
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, '1');

  var ctx = splashCanvas.getContext('2d');
  var W = 0;
  var H = 0;
  var DPR = 1;
  var raf = null;
  var startTime = 0;
  var finished = false;
  var particles = [];
  var siteParticles = [];
  var siteRaf = null;
  var siteCtx = null;
  var siteStartTime = 0;
  var logoW = 380;
  var logoH = 150;
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;

  /* Timing controls */
  var SMOKE_BUILD = 2000;   // smoke only before logo appears
  var LOGO_REVEAL = 1250;   // logo rises out of smoke
  var CENTER_HOLD = 420;    // quick pause in the center
  var DART_RIGHT = 440;     // fast launch off-screen
  var SMOKE_FADE = 650;     // smoke fades after launch
  var TOTAL_TIME = SMOKE_BUILD + LOGO_REVEAL + CENTER_HOLD + DART_RIGHT + SMOKE_FADE;
  var MAX_PARTICLES = isMobile ? 430 : 760;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function easeOutCubic(t) {
    t = clamp(t, 0, 1);
    return 1 - Math.pow(1 - t, 3);
  }

  function easeInCubic(t) {
    t = clamp(t, 0, 1);
    return t * t * t;
  }

  function easeInOutCubic(t) {
    t = clamp(t, 0, 1);
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function resize() {
    DPR = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth;
    H = window.innerHeight;

    splashCanvas.width = Math.floor(W * DPR);
    splashCanvas.height = Math.floor(H * DPR);
    splashCanvas.style.width = W + 'px';
    splashCanvas.style.height = H + 'px';
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);

    if (siteCanvas && siteCtx) {
      siteCanvas.width = Math.floor(W * DPR);
      siteCanvas.height = Math.floor(H * DPR);
      siteCanvas.style.width = W + 'px';
      siteCanvas.style.height = H + 'px';
      siteCtx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    var rect = logoImg.getBoundingClientRect();
    logoW = rect.width || (isMobile ? 260 : 380);
    logoH = rect.height || Math.round(logoW * 0.38);
  }

  function Particle(x, y, opts) {
    opts = opts || {};
    this.x = x;
    this.y = y;
    this.vx = opts.vx || 0;
    this.vy = opts.vy || -0.45;
    this.r = opts.r || 55;
    this.growth = opts.growth || 0.32;
    this.alpha = 0;
    this.maxAlpha = opts.maxAlpha || 0.08;
    this.life = 0;
    this.maxLife = opts.maxLife || 210;
    this.fadeIn = opts.fadeIn || 34;
    this.fadeOutAt = opts.fadeOutAt || 0.58;
    this.color = opts.color || '205,205,198';
    this.wobble = Math.random() * Math.PI * 2;
    this.wobbleSpeed = opts.wobbleSpeed || (0.015 + Math.random() * 0.025);
    this.wobbleAmount = opts.wobbleAmount || (0.12 + Math.random() * 0.32);
  }

  Particle.prototype.update = function () {
    this.life += 1;
    this.wobble += this.wobbleSpeed;
    this.x += this.vx + Math.sin(this.wobble) * this.wobbleAmount;
    this.y += this.vy;
    this.r += this.growth;

    if (this.life < this.fadeIn) {
      this.alpha = this.maxAlpha * (this.life / this.fadeIn);
    } else if (this.life > this.maxLife * this.fadeOutAt) {
      var fadeT = (this.life - this.maxLife * this.fadeOutAt) / (this.maxLife * (1 - this.fadeOutAt));
      this.alpha = this.maxAlpha * (1 - clamp(fadeT, 0, 1));
    } else {
      this.alpha = this.maxAlpha;
    }

    return this.life < this.maxLife && this.alpha > 0.002;
  };

  Particle.prototype.draw = function (drawCtx, globalAlpha) {
    var a = this.alpha * globalAlpha;
    if (a <= 0) return;

    var g = drawCtx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.r);
    g.addColorStop(0, 'rgba(' + this.color + ',' + a + ')');
    g.addColorStop(0.42, 'rgba(' + this.color + ',' + (a * 0.54) + ')');
    g.addColorStop(1, 'rgba(' + this.color + ',0)');

    drawCtx.beginPath();
    drawCtx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    drawCtx.fillStyle = g;
    drawCtx.fill();
  };

  function addParticle(p) {
    if (particles.length < MAX_PARTICLES) {
      particles.push(p);
    }
  }

  function smokeColor(tealChance) {
    if (Math.random() < tealChance) return '58,137,152';
    if (Math.random() < 0.55) return '205,205,198';
    return '145,150,148';
  }

  function spawnBottomSmoke(amount, intensity) {
    var i;
    var bandTop = H * 0.74;
    var bandHeight = H * 0.22;
    var baseR = isMobile ? 34 : 46;

    for (i = 0; i < amount; i += 1) {
      var centerBias = (Math.random() + Math.random()) / 2;
      var x = W * centerBias + (Math.random() - 0.5) * W * 0.18;
      var y = bandTop + Math.random() * bandHeight;
      var r = baseR + Math.random() * (isMobile ? 58 : 88) + intensity * 18;

      addParticle(new Particle(x, y, {
        vx: (Math.random() - 0.5) * (0.28 + intensity * 0.55),
        vy: -(0.18 + Math.random() * (0.42 + intensity * 0.38)),
        r: r,
        growth: 0.18 + Math.random() * 0.34,
        maxAlpha: (0.035 + Math.random() * 0.08) * (0.75 + intensity * 0.45),
        maxLife: 185 + Math.random() * 150,
        fadeIn: 28 + Math.random() * 28,
        fadeOutAt: 0.54 + Math.random() * 0.16,
        color: smokeColor(0.18 + intensity * 0.12),
        wobbleAmount: 0.12 + Math.random() * 0.42
      }));
    }
  }

  function spawnLogoSmoke(amount, logoX, logoY, intensity) {
    var i;
    var cx = W / 2 + logoX;
    var cy = H / 2 + logoY + logoH * 0.30;

    for (i = 0; i < amount; i += 1) {
      addParticle(new Particle(
        cx + (Math.random() - 0.5) * logoW * (0.7 + intensity * 0.4),
        cy + Math.random() * logoH * 0.22,
        {
          vx: (Math.random() - 0.5) * 0.48,
          vy: -(0.22 + Math.random() * 0.55),
          r: (isMobile ? 18 : 24) + Math.random() * (isMobile ? 34 : 48),
          growth: 0.14 + Math.random() * 0.22,
          maxAlpha: 0.04 + Math.random() * 0.075,
          maxLife: 125 + Math.random() * 105,
          fadeIn: 18 + Math.random() * 18,
          fadeOutAt: 0.48 + Math.random() * 0.18,
          color: smokeColor(0.28),
          wobbleAmount: 0.08 + Math.random() * 0.24
        }
      ));
    }
  }

  function spawnLaunchTrail(amount, logoX, logoY, dartT) {
    var i;
    var cx = W / 2 + logoX - logoW * 0.35;
    var cy = H / 2 + logoY;

    for (i = 0; i < amount; i += 1) {
      addParticle(new Particle(
        cx + (Math.random() - 0.5) * logoW * 0.38,
        cy + (Math.random() - 0.5) * logoH * 0.7,
        {
          vx: -(1.2 + Math.random() * 2.8 + dartT * 3.6),
          vy: (Math.random() - 0.5) * 0.9,
          r: (isMobile ? 16 : 22) + Math.random() * (isMobile ? 34 : 54),
          growth: 0.22 + Math.random() * 0.38,
          maxAlpha: 0.055 + Math.random() * 0.09,
          maxLife: 70 + Math.random() * 75,
          fadeIn: 7 + Math.random() * 10,
          fadeOutAt: 0.32 + Math.random() * 0.18,
          color: smokeColor(0.42),
          wobbleAmount: 0.1 + Math.random() * 0.35
        }
      ));
    }
  }

  function drawBottomHaze(globalAlpha) {
    var g = ctx.createLinearGradient(0, H * 0.58, 0, H);
    g.addColorStop(0, 'rgba(18,18,18,0)');
    g.addColorStop(0.56, 'rgba(18,18,18,' + (0.22 * globalAlpha) + ')');
    g.addColorStop(1, 'rgba(18,18,18,' + (0.68 * globalAlpha) + ')');
    ctx.fillStyle = g;
    ctx.fillRect(0, H * 0.55, W, H * 0.45);
  }

  function setLogo(x, y, opacity, scaleX, scaleY, blur, glow, launchClass) {
    logoWrap.style.left = '50%';
    logoWrap.style.top = '50%';
    logoWrap.style.bottom = 'auto';
    logoWrap.style.opacity = opacity.toFixed(3);
    logoWrap.style.transform = 'translate3d(-50%, -50%, 0) translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) scale(' + scaleX.toFixed(3) + ',' + scaleY.toFixed(3) + ')';

    if (launchClass) {
      logoWrap.classList.add('llc-launching');
    } else {
      logoWrap.classList.remove('llc-launching');
    }

    logoImg.style.filter = 'blur(' + blur.toFixed(2) + 'px) drop-shadow(0 0 ' + glow.toFixed(1) + 'px rgba(58,137,152,0.55))';
  }

  function shakeScreen(amount) {
    if (amount <= 0) {
      splash.style.transform = 'translate3d(0,0,0)';
      return;
    }

    var x = (Math.random() - 0.5) * amount;
    var y = (Math.random() - 0.5) * amount;
    splash.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0)';
  }


  function spawnSiteSmoke(amount, alphaBoost) {
    if (!siteCanvas || !siteCtx) return;

    for (var i = 0; i < amount; i += 1) {
      siteParticles.push(new Particle(
        W * (0.08 + Math.random() * 0.84),
        H * (0.80 + Math.random() * 0.18),
        {
          vx: (Math.random() - 0.5) * 0.45,
          vy: -(0.20 + Math.random() * 0.35),
          r: (isMobile ? 34 : 48) + Math.random() * (isMobile ? 58 : 86),
          growth: 0.16 + Math.random() * 0.28,
          maxAlpha: (0.035 + Math.random() * 0.065) * (alphaBoost || 1),
          maxLife: 145 + Math.random() * 160,
          fadeIn: 22 + Math.random() * 24,
          fadeOutAt: 0.48 + Math.random() * 0.18,
          color: smokeColor(0.26),
          wobbleAmount: 0.12 + Math.random() * 0.36
        }
      ));
    }
  }

  function stopSiteSmoke() {
    if (siteRaf) cancelAnimationFrame(siteRaf);
    siteRaf = null;
    siteParticles = [];
    siteStartTime = 0;

    if (siteCtx) siteCtx.clearRect(0, 0, W, H);
    if (siteCanvas) siteCanvas.style.display = 'none';
  }

  function startSiteSmokeOnce() {
    if (!siteCanvas || sessionStorage.getItem(HOME_SMOKE_KEY)) return;

    sessionStorage.setItem(HOME_SMOKE_KEY, '1');
    siteCtx = siteCanvas.getContext('2d');
    resize();

    siteCanvas.style.display = 'block';
    siteCanvas.style.opacity = '1';

    function siteLoop(ts) {
      if (!siteStartTime) siteStartTime = ts;
      var elapsed = ts - siteStartTime;
      var liveTime = 4200;
      var fadeTime = 900;
      var total = liveTime + fadeTime;
      var fadeT = elapsed <= liveTime ? 1 : 1 - clamp((elapsed - liveTime) / fadeTime, 0, 1);

      siteCtx.clearRect(0, 0, W, H);

      if (elapsed < liveTime) {
        spawnSiteSmoke(isMobile ? 2 : 4, 1);
      }

      siteParticles = siteParticles.filter(function (p) {
        var alive = p.update();
        if (alive) p.draw(siteCtx, fadeT);
        return alive;
      });

      if (elapsed < total || siteParticles.length > 0) {
        siteRaf = requestAnimationFrame(siteLoop);
      } else {
        stopSiteSmoke();
      }
    }

    siteRaf = requestAnimationFrame(siteLoop);
  }

  function revealSite() {
    if (finished) return;
    finished = true;

    if (raf) cancelAnimationFrame(raf);
    if (skipBtn && skipBtn.parentNode) skipBtn.parentNode.removeChild(skipBtn);

    splash.style.transform = 'translate3d(0,0,0)';
    splash.style.pointerEvents = 'none';
    logoWrap.style.opacity = '0';
    splashCanvas.style.transition = 'opacity 0.18s ease';
    splashCanvas.style.opacity = '0';

    // Start shatter immediately — canvas sits on top of splash
    runPixelShatter(function () {
      splash.style.display = 'none';
    });
  }

  function runPixelShatter(onDone) {
    var cW = window.innerWidth;
    var cH = window.innerHeight;

    // Hide splash first so homepage is visible underneath
    splash.style.display = 'none';

    // Shatter canvas sits on top of everything on body
    var shatterCanvas = document.createElement('canvas');
    shatterCanvas.style.cssText = 'position:fixed;top:0;left:0;pointer-events:none;z-index:100000;';
    shatterCanvas.width = Math.floor(cW * DPR);
    shatterCanvas.height = Math.floor(cH * DPR);
    shatterCanvas.style.width = cW + 'px';
    shatterCanvas.style.height = cH + 'px';
    document.body.appendChild(shatterCanvas);

    var sc = shatterCanvas.getContext('2d');
    sc.setTransform(DPR, 0, 0, DPR, 0, 0);

    // Draw all black tiles up front
    var COLS = isMobile ? 9 : 16;
    var ROWS = isMobile ? 7 : 10;
    var cellW = cW / COLS;
    var cellH = cH / ROWS;
    var duration = 1100;

    var cells = [];
    for (var r = 0; r < ROWS; r++) {
      for (var c = 0; c < COLS; c++) {
        cells.push({ r: r, c: c });
      }
    }
    for (var i = cells.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = cells[i]; cells[i] = cells[j]; cells[j] = tmp;
    }

    // Draw initial full black so first frame is solid
    sc.fillStyle = '#121212';
    sc.fillRect(0, 0, cW, cH);

    var safetyTimer = window.setTimeout(function() {
      if (shatterCanvas.parentNode) shatterCanvas.parentNode.removeChild(shatterCanvas);
    }, duration + 500);

    var startTs = null;
    function frame(ts) {
      if (!startTs) startTs = ts;
      var elapsed = ts - startTs;
      var progress = Math.min(elapsed / duration, 1);
      var clearedCount = Math.floor(progress * cells.length);

      // Clear entire canvas (shows homepage through)
      sc.clearRect(0, 0, cW, cH);

      // Redraw only remaining black tiles
      sc.fillStyle = '#121212';
      for (var k = clearedCount; k < cells.length; k++) {
        var cell = cells[k];
        var distFromEdge = k - clearedCount;
        if (distFromEdge < 10) {
          var shrink = 0.55 + 0.45 * (distFromEdge / 10);
          var cx = cell.c * cellW + cellW / 2;
          var cy = cell.r * cellH + cellH / 2;
          sc.fillRect(cx - (cellW * shrink) / 2, cy - (cellH * shrink) / 2, cellW * shrink, cellH * shrink);
        } else {
          sc.fillRect(cell.c * cellW, cell.r * cellH, cellW + 1, cellH + 1);
        }
      }

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        window.clearTimeout(safetyTimer);
        if (shatterCanvas.parentNode) shatterCanvas.parentNode.removeChild(shatterCanvas);
        if (onDone) onDone();
      }
    }
    requestAnimationFrame(frame);
  }

  function tick(ts) {
    if (!startTime) startTime = ts;
    var elapsed = ts - startTime;
    var x = 0;
    var y = H * 0.34;
    var opacity = 0;
    var scaleX = 0.96;
    var scaleY = 0.96;
    var blur = 5;
    var glow = 0;
    var smokeAlpha = 1;
    var launch = false;

    ctx.clearRect(0, 0, W, H);

    if (elapsed < SMOKE_BUILD) {
      var buildT = easeOutCubic(elapsed / SMOKE_BUILD);
      spawnBottomSmoke(isMobile ? 4 : 7, buildT);
      y = H * 0.34;
      opacity = 0;
      blur = 6;
    } else if (elapsed < SMOKE_BUILD + LOGO_REVEAL) {
      var revealRaw = (elapsed - SMOKE_BUILD) / LOGO_REVEAL;
      var revealT = easeOutCubic(revealRaw);
      y = H * 0.34 * (1 - revealT);
      opacity = clamp((revealRaw - 0.06) / 0.72, 0, 1);
      scaleX = 0.94 + revealT * 0.06;
      scaleY = 0.94 + revealT * 0.06;
      blur = 4.5 * (1 - revealT);
      glow = 8 + revealT * 20;
      spawnBottomSmoke(isMobile ? 3 : 5, 0.95);
      spawnLogoSmoke(isMobile ? 2 : 4, x, y, revealT);
    } else if (elapsed < SMOKE_BUILD + LOGO_REVEAL + CENTER_HOLD) {
      var holdT = (elapsed - SMOKE_BUILD - LOGO_REVEAL) / CENTER_HOLD;
      y = 0;
      opacity = 1;
      scaleX = 1 + Math.sin(holdT * Math.PI) * 0.018;
      scaleY = 1 + Math.sin(holdT * Math.PI) * 0.018;
      blur = 0;
      glow = 22 + Math.sin(holdT * Math.PI) * 14;
      spawnBottomSmoke(isMobile ? 2 : 3, 0.75);
      spawnLogoSmoke(isMobile ? 1 : 2, 0, 0, 0.75);
    } else if (elapsed < SMOKE_BUILD + LOGO_REVEAL + CENTER_HOLD + DART_RIGHT) {
      var dartRaw = (elapsed - SMOKE_BUILD - LOGO_REVEAL - CENTER_HOLD) / DART_RIGHT;
      var dartT = easeInCubic(dartRaw);
      var offscreenDistance = W / 2 + logoW + 160;
      x = offscreenDistance * dartT;
      y = Math.sin(dartRaw * Math.PI) * -8;
      opacity = dartRaw < 0.82 ? 1 : 1 - ((dartRaw - 0.82) / 0.18);
      opacity = clamp(opacity, 0, 1);
      scaleX = 1 + dartRaw * 0.34;
      scaleY = 1 - dartRaw * 0.08;
      blur = 0.3 + dartRaw * 3.2;
      glow = 34 + dartRaw * 30;
      launch = true;
      shakeScreen((1 - dartRaw) * 3.2);
      spawnBottomSmoke(isMobile ? 1 : 2, 0.45);
      spawnLaunchTrail(isMobile ? 5 : 9, x, y, dartRaw);
    } else {
      var fadeRaw = (elapsed - SMOKE_BUILD - LOGO_REVEAL - CENTER_HOLD - DART_RIGHT) / SMOKE_FADE;
      smokeAlpha = 1 - easeInOutCubic(fadeRaw);
      x = W / 2 + logoW + 160;
      y = 0;
      opacity = 0;
      blur = 4;
      shakeScreen(0);
      if (fadeRaw < 0.35) spawnBottomSmoke(isMobile ? 1 : 2, 0.25);
    }

    drawBottomHaze(smokeAlpha);

    particles = particles.filter(function (p) {
      var alive = p.update();
      if (alive) p.draw(ctx, smokeAlpha);
      return alive;
    });

    setLogo(x, y, opacity, scaleX, scaleY, blur, glow, launch);

    if (elapsed >= TOTAL_TIME) {
      revealSite();
      return;
    }

    raf = requestAnimationFrame(tick);
  }

  var skipBtn = document.createElement('button');
  skipBtn.id = 'llc-skip-btn';
  skipBtn.type = 'button';
  skipBtn.textContent = 'Skip';
  document.body.appendChild(skipBtn);
  skipBtn.addEventListener('click', revealSite);

  function start() {
    resize();
    window.addEventListener('resize', resize);

    splash.style.display = 'flex';
    splash.style.opacity = '1';
    splash.style.pointerEvents = 'auto';
    splash.style.transform = 'translate3d(0,0,0)';

    logoWrap.style.left = '50%';
    logoWrap.style.top = '50%';
    logoWrap.style.bottom = 'auto';
    logoWrap.style.opacity = '0';
    logoWrap.style.transform = 'translate3d(-50%, -50%, 0) translate3d(0,' + Math.round(H * 0.34) + 'px,0) scale(0.96)';

    raf = requestAnimationFrame(tick);
  }

  if (logoImg.complete && logoImg.naturalWidth > 0) {
    start();
  } else {
    logoImg.addEventListener('load', start);
    logoImg.addEventListener('error', revealSite);
  }
})();
